export const ADD_DOMAIN_ERROR_ID = 'add-domain-error'
export const BUTTON_ID = 'add-domain-button'
export const CREATE_DOMAIN_DEBOUNCE_MSEC = 300
export const VERIFY_DOMAIN_DEBOUNCE_MSEC = 750
export const DOMAIN_INPUT_ID = 'create-domain-control-input'
export const DOMAIN_STATES = {
  CAPTURED_BY_OTHER_ORG: 'captured_by_other_org',
  PENDING: 'pending',
  VERIFIED: 'verified',
}
export const SELECT_ID = 'verification-method-select'
export const SLICE_INITIAL_STATE = {
  createForm: {
    domain: '',
    error: undefined,
    formDisabled: false,
    loading: false,
    submitDisabled: true,
    verificationMethod: 'txt',
  },
  list: {
    allDomainSummaries: {},
    domainForPopup: null,
    entries: [],
    errors: {},
    expandedCardDomains: {},
    isLoadingActionPopup: false,
    isPopupOpen: false,
    loading: false,
    loadingVerifications: {},
    openPopupType: null,
    reportGeneration: {},
  },
  domainControlSetting: {
    accessOwnerDropdown: {
      loading: false,
      options: []
    },
    accessOwnerType: null,
    accessOwnerValue: null,
    hasExistingSetting: false,
    loading: false,
  }
}
export const VERIFICATION_METHODS = {
  DNS_CNAME: 'cname',
  DNS_TXT: 'txt',
  MANUAL: 'manual'
}
export const CANNOT_VERIFY_WITHIN = {
  unit: 'minutes',
  amount: 5
}

export const REPORT_GENERATION_STATUSES = {
  generated: 'generated',
  pending: 'pending'
}
export const ORG_ADMINS_PAGE_SIZE = 200

// Popup types

export const DELETE_DOMAIN_POPUP = 'delete_domain_popup'
export const ENABLE_DISABLE_DOMAIN_POPUP = 'enable_disable_domain_popup'

// Segment track events
export const SEGMENT_DOMAIN_CONTROL_CONTACT_US_CLICK = 'domain_control.contact_us_clicked'
